import { createRouter } from "@tanstack/solid-router";
import { pluginRoutes } from "@/composition";
import { rootRoute } from "@/routes/__root";
import { NotFoundRoute } from "@/components/not-found-route";
import { authRoute } from "@/routes/_auth/route";
import { loginRoute } from "@/routes/_auth/login";
import { registerRoute } from "@/routes/_auth/register";
import { forgotPasswordRoute } from "@/routes/_auth/forgot-password";
import { resetPasswordRoute } from "@/routes/_auth/reset-password";
import { verifyEmailRoute } from "@/routes/_auth/verify-email";
import { socialCallbackRoute } from "@/routes/_auth/social-callback";
import { appRoute } from "@/routes/_app/route";
import { indexRoute } from "@/routes/_app/index";
import { routinesRoute } from "@/routes/_app/routines";
import { routineDetailRoute } from "@/routes/_app/routines.$routineId";
import { sessionRoute } from "@/routes/_app/session.$sessionId";
import { exercisesRoute } from "@/routes/_app/exercises";
import { exerciseDetailRoute } from "@/routes/_app/exercises.$exerciseId";
import { historyRoute } from "@/routes/_app/history";
import { summaryRoute } from "@/routes/_app/summary";
import { measurementsRoute } from "@/routes/_app/measurements";
import { profileRoute } from "@/routes/_app/profile";
import { debugRoute } from "@/routes/_app/debug";
import { organizationsRoute } from "@/routes/_app/organizations";
import { organizationDetailRoute } from "@/routes/_app/organizations.$orgId";
import { invitationsRoute } from "@/routes/_app/invitations";
import { themeGalleryRoute } from "@/routes/_app/themes";
import { languageRoute } from "@/routes/_app/language";
import { profileFontsRoute } from "@/routes/_app/profile.fonts";
import { profileShortcutsRoute } from "@/routes/_app/profile.shortcuts";
import { profileDeleteAccountRoute } from "@/routes/_app/profile.delete-account";
import { profileTrashRoute } from "@/routes/_app/profile.trash";
import { profileTransferSendRoute } from "@/routes/_app/profile.transfer-send";
import { profileTransferReceiveRoute } from "@/routes/_app/profile.transfer-receive";

const routeTree = rootRoute.addChildren([
  socialCallbackRoute,
  authRoute.addChildren([
    loginRoute,
    registerRoute,
    forgotPasswordRoute,
    resetPasswordRoute,
    verifyEmailRoute,
  ]),
  appRoute.addChildren([
    indexRoute, // path: "/" — Empezar/continuar entrenamiento
    // Pages contributed by the composed plugins. Empty here: GymLog composes no
    // plugin that owns a page. A feature's URL is part of the feature.
    ...pluginRoutes,
    routinesRoute,
    routineDetailRoute,
    sessionRoute,
    exercisesRoute,
    exerciseDetailRoute,
    historyRoute,
    summaryRoute,
    measurementsRoute,
    organizationsRoute,
    organizationDetailRoute,
    invitationsRoute,
    themeGalleryRoute,
    languageRoute,
    profileRoute,
    profileFontsRoute,
    profileShortcutsRoute,
    profileDeleteAccountRoute,
    profileTrashRoute,
    profileTransferSendRoute,
    profileTransferReceiveRoute,
    debugRoute,
  ]),
]);

export const router = createRouter({
  routeTree,
  // Any unknown URL shows a "not found" state with a navigation action
  // instead of a blank screen.
  defaultNotFoundComponent: NotFoundRoute,
  // "intent" preloads only when the user expresses intent (hover/focus on a
  // <Link>). See the listto template for the full rationale: viewport
  // preloading saturated the main thread right after login.
  defaultPreload: "intent",
  // oxlint-disable-next-line eslint(no-magic-numbers)
  defaultPreloadStaleTime: 30_000, // 30 s — don't re-preload the same route within 30 s
});

declare module "@tanstack/solid-router" {
  interface Register {
    router: typeof router;
  }
}
